<template>
  <div
    :class="{
      'switch': true,
      'switch--on': modelValue,
      'switch--disabled': disabled,
      [switchClass ?? '']: true
    }"
    @click="toggle"
  >
    <div class="switch__handle"></div>
  </div>
</template>

<script setup lang="ts">
  import { defineProps, defineEmits } from 'vue'

  // 定义 props 类型
  interface SwitchProps {
    modelValue: boolean
    disabled?: boolean
    switchClass?: string
  }

  // 定义 props
  const props = defineProps<SwitchProps>()

  // 定义 emits 事件
  const emits = defineEmits<{
    (event: 'update:modelValue', value: boolean): void
  }>()

  // 切换开关状态的函数
  const toggle = () => {
    !props.disabled && emits('update:modelValue', !props.modelValue)
  }
</script>

<style scoped lang="stylus">
  .switch {
    display: inline-block;
    position: relative;
    width: 40px;
    height: 20px;
    background-color: #f5f4ff;
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.3s;
    &.switch--on {
      background-color: #6d5dff;
    }
  }

  .switch--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .switch__handle {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 16px;
    height: 16px;
    background-color: #fff;
    border-radius: 50%;
    transition: transform 0.3s;
  }

  .switch--on .switch__handle {
    transform: translateX(20px);
  }
</style>
